<template>
  <div class="traffic">
    <Banner></Banner>
  </div>
</template>

<script>
import Banner from "../../components/common/banner";
export default {
  name: "Traffic",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    //切换标签
    changeDataList(type) { 
      let name = "TrafficTab";
      this.$store.commit("setTabPage", type);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/traffic/index.vue